import { LogEventService } from './../logevent/logeventservice';
import { Component, OnInit, Input } from '@angular/core';
import { MachineService } from '../machine/machineService';
import { Machine } from '../machine/machine';
import { Ticket } from '../ticket/ticket';
import { TicketService } from '../ticket/ticketService';
import { User } from '../user/user';
import { UserService } from '../_services';
import { ClientService } from '../client/clientservice';
import { Client } from '../client/client';
import { Authenticate } from '../authenticate/authenticate';
import { Logevent } from '../logevent/logevent';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less', '../app.component.less'],
  })

 
export class DashboardComponent implements OnInit {

  //#region VARIABLES
  @Input() client: Client;
  @Input() importedMachines: Machine[];

  isCollapsed: boolean = true; // Initially, the component is visible

  toggleMachinesListView() {
    this.isCollapsed = !this.isCollapsed; // Toggle the collapsed state
  }
  History: Logevent[] = [];
  tickets: Ticket[]
  ticket = new Ticket
  currentuser: User;
  auth: Authenticate;
  querycriteria: string;
  searchquery: string;
  jwt: string;
  private userrole: string;
  currentclient: Client;
  machines: Machine[];
  tcount: number = 0;
  mcount: number = 0;
  checked: number = 0;
  p: Number = 1;
  count: Number = 5;
  mcount1: number;
  mcount2: number;
  mcount3: number;
  mcount4: number;
  tcount1: number;
  tcount2: number;
  tcount3: number;
  tcount4: number;
  tcount5: number;

  public chartOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  showHistory = false;

  public machinesChartLabels = ['Down', 'Working', 'Inconsistent', 'Damaged'];
  public machinesChartType = 'doughnut';
  public machinesChartLegend = true;
  machinesChartData =
    [
      {
        data: [20, 20, 44, 90], label: 'Series A'
      }
    ];

  public ticketsChartLabels = ['Open', 'Resolved', 'Pending', 'Closed', 'Waiting '];
  public ticketsChartType = 'doughnut';
  public ticketsChartLegend = true;
  ticketsChartData =
    [
      {
        data: [40, 60, 14, 100, 31], label: 'Series A'
      }
    ];

  //#endregion

  constructor(
    private ticketservice: TicketService,
    private userservice: UserService,
    private machineservice: MachineService,
    private clientservice: ClientService,
    private logeventservice: LogEventService
  ) {

  }


  //  PAGE LOAD FUNCTION
  async ngOnInit() {
    this.currentuser = this.userservice.getCurrentUserFromCookie();
    this.userrole = this.currentuser.role.name;

    //  IF USER IS ADMIN FROM CSG SUPPORT TEAM
    if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
      this.tcount = await (this.ticketservice.getTicketsCount().toPromise());
      this.tcount1 = await (this.ticketservice.getTicketsCount(1).toPromise());
      this.tcount2 = await (this.ticketservice.getTicketsCount(2).toPromise());
      this.tcount3 = await (this.ticketservice.getTicketsCount(3).toPromise());
      this.tcount4 = await (this.ticketservice.getTicketsCount(4).toPromise());
      this.tcount5 = await (this.ticketservice.getTicketsCount(5).toPromise());
      this.ticketsChartData = [{ data: [this.tcount1, this.tcount4, this.tcount2, this.tcount5, this.tcount3], label: 'Series A' }];
      this.mcount = await (this.machineservice.getMachinesCount().toPromise());
      this.mcount1 = await (this.machineservice.getMachinesCount(1).toPromise());
      this.mcount2 = await (this.machineservice.getMachinesCount(2).toPromise());
      this.mcount3 = await (this.machineservice.getMachinesCount(3).toPromise());
      this.mcount4 = await (this.machineservice.getMachinesCount(5).toPromise());
      this.machinesChartData = [{ data: [this.mcount2, this.mcount1, this.mcount3, this.mcount4], label: 'Series A' }];
      this.logeventservice.getLogEvents().subscribe(resp => this.History = resp.reverse());
    }

    //  IF USER IS CLIENT EMPLOYEE
    else {
      this.tcount = await (this.ticketservice.getTicketsCount(undefined, this.currentuser.client.id).toPromise());
      this.tcount1 = await (this.ticketservice.getTicketsCount(1, this.currentuser.client.id).toPromise());
      this.tcount2 = await (this.ticketservice.getTicketsCount(2, this.currentuser.client.id).toPromise());
      this.tcount3 = await (this.ticketservice.getTicketsCount(3, this.currentuser.client.id).toPromise());
      this.tcount4 = await (this.ticketservice.getTicketsCount(4, this.currentuser.client.id).toPromise());
      this.tcount5 = await (this.ticketservice.getTicketsCount(5, this.currentuser.client.id).toPromise());
      this.ticketsChartData = [{ data: [this.tcount1, this.tcount4, this.tcount2, this.tcount5, this.tcount3], label: 'Series A' }];
      this.mcount = await (this.machineservice.getMachinesCount(undefined, this.currentuser.client.id).toPromise());
      this.mcount1 = await (this.machineservice.getMachinesCount(1, this.currentuser.client.id).toPromise());
      this.mcount2 = await (this.machineservice.getMachinesCount(2, this.currentuser.client.id).toPromise());
      this.mcount3 = await (this.machineservice.getMachinesCount(3, this.currentuser.client.id).toPromise());
      this.mcount4 = await (this.machineservice.getMachinesCount(5, this.currentuser.client.id).toPromise());
      this.machinesChartData = [{ data: [this.mcount2, this.mcount1, this.mcount3, this.mcount4], label: 'Series A' }];
      this.logeventservice.getLogEvents().subscribe(resp => this.History = resp.reverse());
    }
  }

}

